<template>
  <div style="display: flex; flex-direction: column;">
  <PrintDialog v-if="$store.state.View.is_printing_mode" name="WalletPrint" file_name="WalletPrint"
  print_el="wallet-print" height_el="wallet-print" width_el="wallet-print-2" 
  />
  <!-- {{ getUObject({type:'tworkpackages', id: $route.params.tworkpackage_id}) }} -->
  <button class="wallet-print-back-button" @click="
              $router.push({
                name: 'TaktPlanWorkPackageInfo',
              })
      ">
    <TIcon name="close" size="40" color="white"/>
  </button>
  <div id="wallet-print">
    <!-- NOTE: DIN A4 IN px -->
    <div id="wallet-print-2" class="workpackage-card-page" :style="`width: ${2480/factor}px; height: ${3508/factor}px; font-size: ${24/factor}pt;`">
      <!-- NOTE: ORIGINAL MEASUREMENTS -->
      <div v-for="i in 6" :key="`page #${i + 1}`" :style="`width: ${826/factor}px; height: ${1358/factor}px; ${getBorder(i)}`">
        <div class="workpackage-card-card" :style="`margin: ${48/factor}px;`">
          <div :class="$store.state.View.is_print_background_color?getUObject({type:'tworkpackages', id: $route.params.tworkpackage_id}).color:''">
          <!-- HEADER -->
          <!-- ICON -->
          <!-- <div :style="`background-color: blue; width: ${200/factor}px; height: ${200/factor}px;`"/> -->
          <TIcon :name="getNewIcon(getUObject({type:'tworkpackages', id: $route.params.tworkpackage_id}).icon)" color="black" :style="`width: ${200/factor}px; height: ${200/factor}px;`"/>

          <!-- WORKPACKAGE -->
          <div class="workpackage-card-workpackage" :style="`height: ${48/factor}px;`">
            <TText value="WORKPACKAGE" color="black" :size="24/factor" font_weight="600" />
          </div>

          </div>
          <!-- LINE -->
          <div class="workpackage-card-line" />

          <!-- BODY -->
          <!-- MANPOWER -->
          <div :style="`height: ${214/factor}px;`">
            <div :style="`margin-top: ${20/factor}px; margin-left: ${14/factor}px; color: black;`">
              <TText value="MANPOWER" color="black" :size="24/factor" />
              <div v-if="$store.state.View.is_print_manpower" style="font-size: x-large;">{{ getUObject({type:'tworkpackages', id: $route.params.tworkpackage_id}).manpower_planned }}</div>
            </div>
          </div>

          <!-- LINE -->
          <div class="workpackage-card-line" />

          <!-- WORKSTEPS -->
          <div :style="`height: ${114/factor}px;`">
            <div :style="`margin-top: ${20/factor}px; margin-left: ${14/factor}px;`">
              <TText value="WORKSTEPS" color="black" :size="24/factor" />
            </div>
          </div>

          <!-- WORKSTEP LIST -->
          <div v-if="$store.state.View.is_print_worksteps" class="workpackage-card-workstep-list-container" :style="`grid-gap: ${96/factor}px;`">
            <div v-for="(tworkstep, j) in getUObjects({ type: 'tworksteps', ids: getUObject({type:'tworkpackages', id: $route.params.tworkpackage_id}).tworksteps }).slice(0, 4)" :key="`step #${j+1}`" class="workpackage-card-flex">
              <div class="workpackage-card-checkbox" :style="`width: ${60/factor}px; height: ${60/factor}px; margin-bottom: ${16/factor}px; margin-right: ${10/factor}px; margin-left: ${20/factor}px;`"/>
              <TText :text="tworkstep.text" max_lines="1" class="workpackage-card-dotted-line" color="black"/>
              <!-- {{tworkstep.text}}</TText> -->
            </div>

            <div v-for="i in getStepCount" :key="`no_step #${i}`" class="workpackage-card-flex">
              <div class="workpackage-card-checkbox" :style="`width: ${60/factor}px; height: ${60/factor}px; margin-bottom: ${16/factor}px; margin-right: ${10/factor}px; margin-left: ${20/factor}px;`"/>
              <div class="workpackage-card-dotted-line"></div> 
            </div>
          </div>

          <div v-else class="workpackage-card-workstep-list-container" :style="`grid-gap: ${96/factor}px;`">
            <div v-for="i in 4" :key="`no_step #${i}`" class="workpackage-card-flex">
              <div class="workpackage-card-checkbox" :style="`width: ${60/factor}px; height: ${60/factor}px; margin-bottom: ${16/factor}px; margin-right: ${10/factor}px; margin-left: ${20/factor}px;`"/>
              <div class="workpackage-card-dotted-line" style="color: black;"></div> 
            </div>
          </div>


          <!-- FOOTER -->
          <!-- <div class="workpackage-card-footer" :style="`padding-top: ${18/factor}px;`"> -->
          <div :class="$store.state.View.is_print_background_color?getUObject({type:'tworkpackages', id: $route.params.tworkpackage_id}).color + ' workpackage-card-footer':'workpackage-card-footer'" :style="`padding-top: ${18/factor}px;`">

            <!-- ICON -->
            <TIcon :name="getNewIcon(getUObject({type:'tworkpackages', id: $route.params.tworkpackage_id}).icon)" class="workpackage-card-upside-down" color="black" :style="`width: ${100/factor}px; height: ${100/factor}px;`"/>

            <!-- CHECKMARK AND DONE -->
            <div class="workpackage-card-done workpackage-card-upside-down">
              <div class="workpackage-card-flex" :style="`grid-gap: ${10/factor}px;`">
                <TIcon name="check" color="black" :style="`width: ${80/factor}px; height: ${80/factor}px;`"/>
                <TText value="DONE" color="black" :size="24/factor" font_weight="600" :style="`padding-top: ${8/factor}px;`" />
              </div>
            </div>
          </div>

          <!-- ERLEDIGT => DONE -->

          <!-- DESCRIPTION -->
          <div class="workpackage-card-description" :style="`min-height: ${(248 - 16)/factor}px; max-height: ${(248 - 16)/factor}px;`">
          <TText :text="getUObject({type:'tworkpackages', id: $route.params.tworkpackage_id}).name" color="black" :size="32/factor" font_weight="600" :style="`padding-top: ${8/factor}px;`" />
          </div>
        </div>
      </div>
      <div class="wallet-print-footer">
        <b>color-name:</b> {{ getUObject({type:'tworkpackages', id: $route.params.tworkpackage_id}).color }}
        <br/>
        <b>color-code (hex):</b> {{ getColor(getUObject({type:'tworkpackages', id: $route.params.tworkpackage_id}).color) }}
      </div>
    </div>
  </div>
</div>
</template>

<script>
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue'
import PrintDialog from '@/components/StandardComponents/PrintDialog.component.vue';
import { mapGetters, mapActions } from 'vuex';
import { TColor } from '@/mixins/TColor.mixin.js';

export default {
  name: 'App',

  components: {
    TText,
    TIcon,
    PrintDialog
  },

  mixins: [
    TColor
  ],

  created() {
    let self = this;
    self.requestUObject({
        url: [
          { projects: self.$route.params.tworkpackage_id },
          { trains: self.$route.params.tworkpackage_id },
          { taktareas: self.$route.params.tworkpackage_id },
          { twaggons: self.$route.params.tworkpackage_id },
          { tworkpackages: self.$route.params.tworkpackage_id },
          { tworksteps: '' },
          { showWithEntitiesNormalized: '' }
        ],
        add_u_object: true
      })
  },

  data: () => ({
    factor: 2,
  }),

  computed: {
  ...mapGetters('Ultra', [
      'getUObject',
      // 'requestUObject',
      'getUObjects',
    ]),
    ...mapGetters('WorkPackage', [
      'getNewIcon',
    ]),
    getStepCount(){
      let twork_step_count = this.getUObject({type:'tworkpackages', id: this.$route.params.tworkpackage_id}).twork_step_count;
      if(twork_step_count){
        if(twork_step_count > 4){
          return 0;
        } else {
          return 4 - twork_step_count;
        }
      } else {
        return 4;
      }
    }
  },

  methods: {
    ...mapActions('Ultra', [
      'requestUObject',
      // 'requestUObject',
      // 'addUObject',
      // 'updateUObject',
      // 'deleteUObject',
      // 'addUObjects',
      // 'updateUObjects',
      // 'deleteUObjects',
    ]),
    getBorder(index){
      let css_string = "border-style: hidden; border-color: black; border-width: 1px;"
      if(this.$store.state.View.is_print_cutting_line){
        if(index === 1){
          css_string += "border-right-style: dashed; border-bottom-style: dashed;"
        } else if(index === 2){
          css_string += "border-left-style: dashed; border-right-style: dashed; border-bottom-style: dashed;"
        } else if(index === 3){
          css_string += "border-left-style: dashed; border-bottom-style: dashed;"
        } else if(index === 4){
          css_string += "border-top-style: dashed; border-right-style: dashed; border-bottom-style: dashed;"
        } else if(index === 5){
          css_string += "border-top-style: dashed; border-left-style: dashed; border-right-style: dashed; border-bottom-style: dashed;"
        } else if(index === 6){
          css_string += "border-top-style: dashed; border-left-style: dashed; border-bottom-style: dashed;"
        }
     }
     return css_string;
    }
  }
}
</script>

<style>
#wallet-print {
  /* background-color: black; */
  display: flex;
  justify-content: center;
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: -0.05em;
}
#wallet-print-2 {
  /* background-color: black; */
  display: flex;
  justify-content: center;
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: -0.05em;
}
.wallet-print-footer {
  color:black; 
  font-size: x-large;
}
.wallet-print-back-button {
  color:black; 
  font-size: x-large; 
  align-self: flex-end; 
  padding: 8px;
}
.workpackage-card-page {
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.workpackage-card-card {
  display: flex;
  flex-direction: column;
  position: relative;
}
.workpackage-card-workpackage {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.workpackage-card-line {
  border-bottom: 1px solid black;
}
.workpackage-card-dotted-line {
  border-bottom: 1px dotted black;
  flex-grow: 1;
}
.workpackage-card-checkbox {
  border: 1px solid black;
}
.workpackage-card-workstep-list-container {
  display: flex;
  flex-direction: column;
}
.workpackage-card-footer {
  display: flex;
  justify-content: space-between;
}
.workpackage-card-upside-down {
  transform: rotate(180deg);
}
.workpackage-card-done {
  display: flex;
  align-items: center;
}
.workpackage-card-description {
  position: absolute;
  writing-mode: vertical-rl;
  top:0;
  right: 0;
  text-align: end;
}
.workpackage-card-flex {
  display: flex;
}
/* .workpackage-header {
  background-color: indigo darken-4;
} */
</style>
